import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3b030374")
const _hoisted_1 = { class: "inner" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("期限切れルームを削除")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("半年以上更新がないユーザを削除")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _createElementVNode("p", null, "現在のルーム総数：" + _toDisplayString(_ctx.totalRoom), 1),
      _createElementVNode("p", null, "期限切れのルーム総数：" + _toDisplayString(_ctx.expiredRoom), 1)
    ]),
    _createElementVNode("section", null, [
      _createVNode(_component_custom_button, {
        type: "round",
        class: _normalizeClass({ 'is-not-active': _ctx.expiredRoom === 0 }),
        onClick: _ctx.deleteExpiredRoom
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["class", "onClick"])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("p", null, "半年以上更新がないユーザ：" + _toDisplayString(_ctx.expiredUsers.length), 1)
    ]),
    _createElementVNode("section", null, [
      _createVNode(_component_custom_button, {
        type: "round",
        class: _normalizeClass({ 'is-not-active': _ctx.expiredUsers.length === 0 }),
        onClick: _ctx.deleteExpiredUsers
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["class", "onClick"])
    ])
  ]))
}